import { useEffect, useState } from "react";

import { ReactComponent as EyeOff } from "../../../../resourсes/eye-off.svg";
import { ReactComponent as Eye } from "../../../../resourсes/eye.svg";

import innerStyles from "./inputForFormUniversal.module.css";

export default function InputForFormUniversal({
  register,
  inputProps,
  dataForm,
  externalStyles,
  setValue,
  mode,
  errors = {},
  getValues,
  clearErrors,
  handleCustomButton,
  setError,
}) {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    if (
      inputProps.type === "date" &&
      dataForm?.[inputProps.key]?.includes(".")
    ) {
      const match = dataForm?.[inputProps.key].match(
        /^(\d{2})\.(\d{2})\.(\d{4})$/,
      );
      if (match === null) {
        return "Неверный формат даты";
      }
      const day = match[1];
      const month = match[2];
      const year = match[3];
      dataForm[inputProps.key] = year + "-" + month + "-" + day;
    }
    if (dataForm) {
      setValue(inputProps.key, dataForm?.[inputProps.key]);
    }
  }, [dataForm]);

  const isPasswordField = inputProps.type === "password";

  const inputType = isPasswordField && showPassword ? "text" : inputProps.type;

  return (
    <div className={externalStyles?.[`box-${inputProps.key}`]}>
      {inputProps.type === "checkbox" ? (
        <div className={innerStyles["checkbox-container"]}>
          <input
            type={inputProps.type}
            name={inputProps.key}
            disabled={inputProps.disabled}
            checked={dataForm[inputProps.key]}
            className={`${innerStyles["checkbox-input"]} ${
              inputProps.pointerEvent
                ? ""
                : innerStyles["disabled-pointer-events"]
            }`}
            {...register(inputProps.key)}
          />
          <label
            className={innerStyles?.["checkbox-label"]}
            htmlFor={inputProps.key}
          >
            {inputProps.label}
          </label>
        </div>
      ) : (
        <>
          <div
            className={
              inputProps.customButton
                ? externalStyles?.["custom-button-block"]
                : ""
            }
          >
            {inputProps.label && (
              <label className={innerStyles?.["label"]}>
                {inputProps.label}
                {inputProps.required && mode !== "view" && (
                  <span className={innerStyles["red-dot"]}>*</span>
                )}
              </label>
            )}
            <div
              className={
                inputProps.customButton
                  ? externalStyles?.[`block-${inputProps.key}`]
                  : ""
              }
            >
              {inputProps.textarea ? (
                <textarea
                  id={inputProps.key}
                  type={inputProps.type}
                  rows={inputProps.rows}
                  className={`${innerStyles["form-input"]} ${
                    externalStyles?.input
                  } ${
                    errors[inputProps.key] ? innerStyles["error-border"] : ""
                  }`}
                  disabled={inputProps.disabled || mode === "view"}
                  placeholder={
                    mode !== "view" ? inputProps.placeholder : undefined
                  }
                  {...register(inputProps.key, {
                    onChange: (e) => {
                      e.target.value = inputProps.upperCase
                        ? e.target.value.toUpperCase()
                        : inputProps.dotAutoCorrect
                        ? e.target.value.replace(",", ".")
                        : e.target.value;
                    },
                    required: inputProps.required && `Заполните поле`,
                    maxLength: {
                      value: inputProps.maxLength,
                      message: `Максимум ${inputProps.maxLength} символов`,
                    },
                    pattern: {
                      value: inputProps.pattern && inputProps.pattern.value,
                      message: inputProps.pattern && inputProps.pattern.message,
                    },
                  })}
                />
              ) : (
                <div className={`${innerStyles["form-data"]}`}>
                  <input
                    id={inputProps.key}
                    type={inputType}
                    className={`${innerStyles["form-input"]} ${
                      externalStyles?.input
                    } ${
                      errors[inputProps.key] ? innerStyles["error-border"] : ""
                    }`}
                    disabled={inputProps.disabled || mode === "view"}
                    placeholder={
                      mode !== "view" ? inputProps.placeholder : undefined
                    }
                    {...register(inputProps.key, {
                      onChange: (e) => {
                        e.target.value = inputProps.upperCase
                          ? e.target.value.toUpperCase()
                          : inputProps.dotAutoCorrect
                          ? e.target.value.replace(",", ".")
                          : e.target.value;
                      },
                      required: inputProps.required && `Заполните поле`,
                      validate: {
                        notEmpty: (value) => {
                          if (inputProps.type === "text") {
                            if (value && inputProps.required) {
                              return (
                                !!value.toString().trim() ||
                                "Поле не может быть пробелом"
                              );
                            }
                            return undefined;
                          }
                        },
                        customValidation: (value) => {
                          if (inputProps.hasOwnProperty("customValidation")) {
                            return inputProps.customValidation(
                              value,
                              getValues && getValues(),
                              setError,
                              clearErrors,
                            );
                          }
                        },
                        additionalCustomValidation: (value) => {
                          if (
                            inputProps.hasOwnProperty(
                              "additionalCustomValidation",
                            )
                          ) {
                            return inputProps.additionalCustomValidation(
                              value,
                              getValues && getValues(),
                              setError,
                              clearErrors,
                            );
                          }
                        },
                        max: (value) =>
                          inputProps.max
                            ? inputProps.max >= parseInt(value) ||
                              `Максимальное значение ${inputProps.max}`
                            : undefined,
                      },
                      maxLength: {
                        value: inputProps.maxLength,
                        message: `Максимум ${inputProps.maxLength} символов`,
                      },
                      pattern: {
                        value: inputProps.pattern && inputProps.pattern.value,
                        message:
                          inputProps.pattern && inputProps.pattern.message,
                      },
                    })}
                  />
                  {isPasswordField && (
                    <button
                      type="button"
                      onClick={togglePasswordVisibility}
                      className={`${innerStyles["form-data-password"]}`}
                    >
                      {showPassword ? <EyeOff /> : <Eye />}
                    </button>
                  )}
                </div>
              )}
              {(mode === "add" || mode === "edit") &&
                inputProps.customButton && (
                  <div
                    id={"search"}
                    className={`${externalStyles?.["custom-button"]} ${
                      inputProps.buttonDisabled
                        ? externalStyles?.["custom-button-disabled"]
                        : ""
                    }`}
                    data-key={inputProps.key}
                    disabled={inputProps.buttonDisabled}
                    onClick={(e) =>
                      !inputProps.buttonDisabled && handleCustomButton(e)
                    }
                  >
                    {inputProps.customIcon && (
                      <span
                        data-key={inputProps.key}
                        className={externalStyles?.["custom-icon"]}
                      ></span>
                    )}
                    <span data-key={inputProps.key}>
                      {inputProps.buttonName}
                    </span>
                  </div>
                )}
            </div>
          </div>
          {errors[inputProps.key] && (
            <div className={innerStyles["error-text"]}>
              {errors[inputProps.key].message}
            </div>
          )}
        </>
      )}
    </div>
  );
}
